import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { List } from 'lodash';
import { CodeConversionMstDto, Sgke391aResponse } from 'sg-api';
import { Sgke391aResponseTakusoMemoInfo } from 'sg-api';

@Component({
  selector: 'app-sgke390d-info',
  templateUrl: './sgke390d-info.component.html',
  styleUrl: './sgke390d-info.component.scss'
})
export class Sgke390dInfoComponent implements OnInit, OnDestroy {
  /** 初期化APIの返り値 */
  @Input() initResponse: Sgke391aResponse = null;
  /** 使用者名 */
  @Input() visitormei: String = "";

  /** コード変換マスタマップ */
  @Input() codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 検索結果表示データソース */
  dataSource: MatTableDataSource<Sgke391aResponseTakusoMemoInfo>;

  /** 託送メモ番号表示 */
  getNo(i): string{
    if(this.initResponse.workEnvInfo.takusoMemoInfoList?.length > 0){
      return i + 1;
    } else {
      return "";
    }
  }

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'no',
    'takusoMemo',
  ];

  basicInfDto: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
  ) {
  }
  ngOnInit(): void {

    const info = this.initResponse.workEnvInfo;
    this.basicInfDto = this.fb.group({
      // 供給地点登録番号
      suppntSpno: [{ value: info.suppntSpno, disabled: true },],
      // 使用者名
      siyousya: [{ value: this.visitormei, disabled: true },],
      // 立会要否
      attendanceKahi: [{ value: info.attendanceKahi, disabled: true },],
      // オートロック
      autolockUmuFlg: [{ value: info.autolockUmuFlg, disabled: true },],
      // 暗証番号
      autolockPin: [{ value: info.autolockPin, disabled: true },],
      // 鍵保管場所
      autolockKeyStoragelocation: [{ value: info.autolockKeyStoragelocation, disabled: true },],
    });

    var takusoMemoInfoList: Sgke391aResponseTakusoMemoInfo[];
    if(info.takusoMemoInfoList?.length > 0){
      takusoMemoInfoList = info.takusoMemoInfoList;
    } else {
      takusoMemoInfoList = [{takusoMemo:""}];
    }

    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke391aResponseTakusoMemoInfo>(
      takusoMemoInfoList,
    );
    this.cd.detectChanges();
  }
  ngOnDestroy(): void {
  }

}
